<script setup lang="ts">
import { computed } from 'vue';
import { bool, func, object } from 'vue-types';

import useFileContentServicesSearch from './Search/useFileContentServiceSearch';

import type { FileContentServiceFragmentFragment, FileFragmentFragment, FileContentFragmentFragment } from '@/graphql/generated/graphql';
import NoDataUrql from '@/ui/NoDataUrql/NoDataUrql.vue';
import Skeletons from '@/ui/Skeletons.vue';

const props = defineProps({
  getLink: func<(data: FileContentServiceFragmentFragment) => string>(),
  onClick: func<(data: FileContentServiceFragmentFragment) => void>(),
  setUrl: bool(),
  onSelect: func<(data: FileContentFragmentFragment) => void>(),
  file: object<FileFragmentFragment>().isRequired,
});
const search = useFileContentServicesSearch(computed(() => props.file.id), props.setUrl);
</script>
<template>
  <NoDataUrql
    v-if="!search.data.value?.data"
    :error="search.error.value"
    :fetching="search.fetching.value"
  >
    <Skeletons :total="10" :avatar="false" :paragraph="false" />
  </NoDataUrql>
  <FileContentServiceTableBase
    v-if="search.data.value?.data"
    :pagination="search.data.value.paginatorInfo"
    :data-source="search.data.value.data"
    :loading="search.fetching.value"
    :get-link="getLink"
    :on-click="onClick"
    :refetch="search.refetch"
    :query="search.query.value"
    :set-query="search.setQuery"
    :file="file"
    :on-select="onSelect"
  >
    <template #top_pag_left>
      <FileContentServiceCreateButton :file-id="file.id" />
    </template>
  </FileContentServiceTableBase>
</template>
